/* OS JV CVR – Top Shop (scoped, no global pollution) */
(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function initOne(root) {
    if (!root || root.dataset.osjvInit === "1") return;
    root.dataset.osjvInit = "1";

    var optionBtns = qsa(root, '[data-osjv-option]');
    var giftEls = qsa(root, '[data-osjv-gift]');
    var rebillEl = qs(root, '[data-osjv-rebill]');
    var ctaEl = qs(root, '[data-osjv-cta]');
    var tryOnceEl = qs(root, '[data-osjv-try-once]');

    var stickyWrap = qs(root, '[data-osjv-sticky-cta-wrap]');
    var stickyCtaEl = qs(root, '[data-osjv-sticky-cta]');
    var stickyCtaCompareEl = qs(root, '[data-osjv-sticky-cta-compare]');
    var stickyCtaPriceEl = qs(root, '[data-osjv-sticky-cta-price]');

    var selectFlavorsBase = root.getAttribute('data-osjv-select-flavors-url') || '';
    var tryOnceBase = root.getAttribute('data-osjv-try-once-url') || selectFlavorsBase;

    var currentQty = 1;
    var currentIntervalDays = '';
    var benefitRefillEl = qs(root, '[data-osjv-benefit-refill]');
    var ctaCompareEl = qs(root, '[data-osjv-cta-compare]');
    var ctaPriceEl = qs(root, '[data-osjv-cta-price]');
    var desktopGalleryQuery = window.matchMedia ? window.matchMedia('(min-width: 991px)') : null;
    var isDesktopGallery = !desktopGalleryQuery || desktopGalleryQuery.matches;
    var activeMainImgEl = isDesktopGallery
      ? qs(root, '.osjv-main-img--desktop')
      : (qs(root, '.osjv-main-img--mobile') || qs(root, '.osjv-main-img--desktop'));
    var mainImgEls = activeMainImgEl
      ? [activeMainImgEl]
      : qsa(root, '[data-osjv-main-img], .osjv-main-img');

    var thumbBtns = qsa(root, '[data-osjv-thumb]').filter(function (btn) {
      if (btn.hasAttribute('data-osjv-desktop-only')) return isDesktopGallery;
      if (btn.hasAttribute('data-osjv-mobile-only')) return !isDesktopGallery;
      return true;
    });

    thumbBtns.forEach(function (btn, index) {
      btn.setAttribute('aria-label', 'View image ' + (index + 1));
    });

    var benefitItems = qsa(root, '[data-osjv-benefit-item]');

    /* =========================================================
       Gallery Preload (fast first-time prev/next)
       - Preloads nearby slides immediately
       - Then idles the rest so switching feels instant
       ========================================================= */

    var __osjvPreloadCache = {};

    function __osjvPreloadOne(btn) {
      if (!btn) return;
      var src = btn.getAttribute('data-src') || '';
      if (!src) return;

      if (__osjvPreloadCache[src]) return;
      __osjvPreloadCache[src] = 1;

      try {
        var img = new Image();
        var srcset = btn.getAttribute('data-srcset') || '';
        if (srcset) img.srcset = srcset;
        img.src = src;
      } catch (e) {}
    }

    function __osjvPreloadAround(index, forwardCount, backwardCount) {
      if (!thumbBtns || !thumbBtns.length) return;

      var fwd = typeof forwardCount === 'number' ? forwardCount : 3;
      var back = typeof backwardCount === 'number' ? backwardCount : 1;

      // Preload current + next few + previous few
      __osjvPreloadOne(thumbBtns[index]);

      for (var i = 1; i <= fwd; i++) {
        __osjvPreloadOne(thumbBtns[wrapIndex(index + i, thumbBtns.length)]);
      }

      for (var j = 1; j <= back; j++) {
        __osjvPreloadOne(thumbBtns[wrapIndex(index - j, thumbBtns.length)]);
      }
    }

    function __osjvIdlePreloadAll() {
      if (!thumbBtns || !thumbBtns.length) return;

      var i = 0;

      function step() {
        // preload a few per tick to avoid blocking UI
        var batch = 3;

        while (batch-- > 0 && i < thumbBtns.length) {
          __osjvPreloadOne(thumbBtns[i]);
          i++;
        }

        if (i < thumbBtns.length) {
          // keep yielding to the browser
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(step, { timeout: 1200 });
          } else {
            window.setTimeout(step, 60);
          }
        }
      }

      // Start soon, but don’t compete with initial paint
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(step, { timeout: 1200 });
      } else {
        window.setTimeout(step, 300);
      }
    }

    var mainPrevBtn = qs(root, '[data-osjv-main-prev]');
    var mainNextBtn = qs(root, '[data-osjv-main-next]');
    var currentMainIndex = 0;

    var nutritionOpenBtns = qsa(root, '[data-osjv-nutrition-open]');
    var nutritionModal = qs(root, '[data-osjv-nutrition-modal]');
    var nutritionDialog = qs(root, '[data-osjv-nutrition-dialog]');
    var nutritionCloseBtn = qs(root, '[data-osjv-nutrition-close]');

    var nutritionCarousel = qs(root, '[data-osjv-nutrition-carousel]');
    var nutritionSlides = qsa(root, '[data-osjv-nutrition-slide]');
    var nutritionPrevBtn = qs(root, '[data-osjv-nutrition-prev]');
    var nutritionNextBtn = qs(root, '[data-osjv-nutrition-next]');
    var currentSlideIndex = 0;

    function wrapIndex(i, len) {
      if (!len) return 0;
      var n = i % len;
      if (n < 0) n = n + len;
      return n;
    }

    function showNutritionSlideByIndex(idx) {
      if (!nutritionSlides || !nutritionSlides.length) return;

      currentSlideIndex = wrapIndex(idx, nutritionSlides.length);

      nutritionSlides.forEach(function (slide, i) {
        if (i === currentSlideIndex) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });

      // Disable nav if only 1 slide (Liquid/CSS also hides, but this is safe)
      if (nutritionPrevBtn) nutritionPrevBtn.disabled = nutritionSlides.length <= 1;
      if (nutritionNextBtn) nutritionNextBtn.disabled = nutritionSlides.length <= 1;
    }

    // Init: show first slide (if any)
    showNutritionSlideByIndex(0);

    if (nutritionPrevBtn) {
      nutritionPrevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showNutritionSlideByIndex(currentSlideIndex - 1);
      });
    }

    if (nutritionNextBtn) {
      nutritionNextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showNutritionSlideByIndex(currentSlideIndex + 1);
      });
    }

    var lastActiveEl = null;
    var prevHtmlOverflow = '';
    var prevBodyOverflow = '';
    var prevBodyPaddingRight = '';

    /* ✅ iOS-safe scroll lock state */
    var prevBodyPosition = '';
    var prevBodyTop = '';
    var prevBodyLeft = '';
    var prevBodyRight = '';
    var prevBodyWidth = '';
    var lockedScrollY = 0;

    function setMainImage(src, srcset) {
      if (!mainImgEls || !mainImgEls.length) return;

      mainImgEls.forEach(function (img) {
        if (!img) return;
        if (src) img.setAttribute('src', src);
        if (srcset) img.setAttribute('srcset', srcset);
      });
    }

    function syncMainNavButtons() {
      var hasMany = thumbBtns && thumbBtns.length > 1;

      if (mainPrevBtn) {
        if (hasMany) mainPrevBtn.removeAttribute('hidden');
        else mainPrevBtn.setAttribute('hidden', '');
        mainPrevBtn.disabled = !hasMany;
      }

      if (mainNextBtn) {
        if (hasMany) mainNextBtn.removeAttribute('hidden');
        else mainNextBtn.setAttribute('hidden', '');
        mainNextBtn.disabled = !hasMany;
      }
    }

    function showMainByIndex(idx) {
      if (!thumbBtns || !thumbBtns.length) return;

      currentMainIndex = wrapIndex(idx, thumbBtns.length);
      var btn = thumbBtns[currentMainIndex];
      if (!btn) return;

      thumbBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      setMainImage(btn.getAttribute('data-src'), btn.getAttribute('data-srcset'));

      // Preload around the new index so next/prev feels instant
      __osjvPreloadAround(currentMainIndex, 3, 1);

      // Keep the active thumb visible in the scroll row (safe fallback)
      try {
        btn.scrollIntoView({ block: 'nearest', inline: 'center' });
      } catch (e) {}

      syncMainNavButtons();
    }

    var quantityMediaRecords = qsa(root, '[data-osjv-quantity-media]');
    var quantityMediaPreloadCache = {};

    function preloadQuantityImage(src, srcset, sizes, cacheKey) {
      if (!src || quantityMediaPreloadCache[cacheKey]) return;

      try {
        var img = new Image();
        img.decoding = 'async';
        img.loading = 'eager';

        if (sizes) img.sizes = sizes;
        if (srcset) img.srcset = srcset;

        img.src = src;
        quantityMediaPreloadCache[cacheKey] = img;

        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
      } catch (e) {}
    }

    function preloadAllQuantityMedia() {
      if (!quantityMediaRecords.length) return;

      var prefix = isDesktopGallery ? 'desktop' : 'mobile';
      var sizes = isDesktopGallery ? '56vw' : '92vw';

      quantityMediaRecords.forEach(function (record) {
        var src = record.getAttribute('data-' + prefix + '-src') || '';
        var srcset = record.getAttribute('data-' + prefix + '-srcset') || '';
        var thumbSrc = record.getAttribute('data-' + prefix + '-thumb') || '';

        preloadQuantityImage(src, srcset, sizes, 'main:' + src);
        preloadQuantityImage(thumbSrc, '', '56px', 'thumb:' + thumbSrc);
      });
    }

    preloadAllQuantityMedia();

    function updateMainMediaForQuantity(qty) {
      if (!quantityMediaRecords.length || !thumbBtns.length) return;

      var qtyKey = String(qty || '');
      var record = quantityMediaRecords.find(function (item) {
        return item.getAttribute('data-qty') === qtyKey;
      });

      if (!record) return;

      var prefix = isDesktopGallery ? 'desktop' : 'mobile';
      var src = record.getAttribute('data-' + prefix + '-src') || '';
      var srcset = record.getAttribute('data-' + prefix + '-srcset') || '';
      var thumbSrc = record.getAttribute('data-' + prefix + '-thumb') || src;

      if (!src) return;

      var overrideThumb = thumbBtns.find(function (btn) {
        return isDesktopGallery
          ? btn.hasAttribute('data-osjv-desktop-only')
          : btn.hasAttribute('data-osjv-mobile-only');
      });

      if (!overrideThumb) return;

      overrideThumb.setAttribute('data-src', src);

      if (srcset) {
        overrideThumb.setAttribute('data-srcset', srcset);
      } else {
        overrideThumb.removeAttribute('data-srcset');
      }

      var overrideThumbImg = qs(overrideThumb, 'img');
      if (overrideThumbImg) {
        overrideThumbImg.setAttribute('src', thumbSrc);

        if (thumbSrc) {
          overrideThumbImg.setAttribute('srcset', thumbSrc);
        } else {
          overrideThumbImg.removeAttribute('srcset');
        }
      }

      var overrideIndex = thumbBtns.indexOf(overrideThumb);
      showMainByIndex(overrideIndex > -1 ? overrideIndex : 0);
    }

    function syncQuantityMainMediaFromSelectedOption() {
      var selectedOption = optionBtns.find(function (btn) {
        return btn.getAttribute('aria-pressed') === 'true';
      });

      if (!selectedOption) return;
      updateMainMediaForQuantity(selectedOption.getAttribute('data-qty'));
    }

    if (quantityMediaRecords.length && optionBtns.length && 'MutationObserver' in window) {
      var quantityMediaObserver = new MutationObserver(function () {
        syncQuantityMainMediaFromSelectedOption();
      });

      optionBtns.forEach(function (btn) {
        quantityMediaObserver.observe(btn, {
          attributes: true,
          attributeFilter: ['aria-pressed']
        });
      });
    }

    function moneyToCents(str) {
      if (!str) return null;
      var m = String(str).match(/-?\d[\d,]*\.?\d*/);
      if (!m) return null;
      var n = parseFloat(m[0].replace(/,/g, ''));
      if (isNaN(n)) return null;
      return Math.round(n * 100);
    }

    function formatCents(cents) {
      if (cents === null || typeof cents === 'undefined') return '';
      var val = (Math.round(cents) / 100).toFixed(2);
      return '$' + val;
    }

    function buildRefillBenefitLine(qty, intervalDays, eachPriceText, nounOverride) {
      var q = parseInt(qty || 1, 10);
      if (!q || q < 1) q = 1;

      var days = parseInt(intervalDays || 0, 10);
      var daysText = days ? String(days) : '';

      var noun = String(nounOverride || '').trim().toLowerCase();

      // Only allow explicit overrides of "bag" or "bags"
      if (noun !== 'bag' && noun !== 'bags') noun = '';

      if (!noun) noun = (q === 1 ? 'bag' : 'bags');

      var eachPrice = String(eachPriceText || '').trim();

      // If editor left price blank, try to infer from the existing refill_line dollar value.
      // (This is a fallback only — best practice is to set refill_each_price.)
      if (!eachPrice) {
        eachPrice = '';
      }

      var out = String(q) + ' ' + noun + ' refilled';
      if (daysText) out += ' every ' + daysText + ' days';
      if (eachPrice) out += ' at ' + eachPrice + ' each';

      return out;
    }

    function persistGiftsState() {
      try {
        // Carry the selected quantity to Select Flavors so gifts can preload unlocked
        sessionStorage.setItem('osjv_gifts_qty_v1', String(currentQty || 1));
      } catch (e) {}
    }

    function buildUrl(base, params) {
      if (!base) return '';
      try {
        var u = new URL(base, window.location.origin);
        Object.keys(params || {}).forEach(function (k) {
          if (params[k] === null || typeof params[k] === 'undefined' || params[k] === '') return;
          u.searchParams.set(k, String(params[k]));
        });
        return u.pathname + (u.search ? u.search : '');
      } catch (e) {
        return base;
      }
    }

    function syncStickyCta() {
      if (!stickyWrap || !stickyCtaEl) return;

      // Sync href / data-osjv-href
      if (ctaEl) {
        if (ctaEl.tagName === 'A') {
          var href = ctaEl.getAttribute('href') || '';
          if (stickyCtaEl.tagName === 'A') stickyCtaEl.setAttribute('href', href || '#');
          else stickyCtaEl.setAttribute('data-osjv-href', href || '');
        } else {
          var dataHref = ctaEl.getAttribute('data-osjv-href') || '';
          if (stickyCtaEl.tagName === 'A') stickyCtaEl.setAttribute('href', dataHref || '#');
          else stickyCtaEl.setAttribute('data-osjv-href', dataHref || '');
        }
      }

      // Sync compare/price texts
      if (stickyCtaCompareEl && ctaCompareEl) stickyCtaCompareEl.textContent = ctaCompareEl.textContent || '';
      if (stickyCtaPriceEl && ctaPriceEl) stickyCtaPriceEl.textContent = ctaPriceEl.textContent || '';
    }

    function updateBenefitsVisibility() {
      if (!benefitItems || !benefitItems.length) return;

      var qtyStr = String(currentQty || 1);

      benefitItems.forEach(function (li) {
        if (!li) return;

        var showList = li.getAttribute('data-show-qtys') || '';
        showList = String(showList || '').trim();

        // Blank => always show
        if (!showList) {
          li.removeAttribute('hidden');
          li.style.display = '';
          return;
        }

        // Comma-separated list of qty values (must match option block qty)
        var allowed = showList.split(',').map(function (s) { return String(s).trim(); }).filter(Boolean);

        if (allowed.indexOf(qtyStr) > -1) {
          li.removeAttribute('hidden');
          li.style.display = '';
        } else {
          li.setAttribute('hidden', '');
          li.style.display = 'none';
        }
      });
    }

    function updateSelectFlavorsLink() {
      if (!ctaEl) return;

      var url = buildUrl(selectFlavorsBase, {
        quantity: currentQty,
        plan: 'subscription',
        frequency: currentIntervalDays || ''
      });

      // If it’s an <a>, update href. If it’s a <button>, click handler will use url.
      if (ctaEl.tagName === 'A') {
        ctaEl.setAttribute('href', url || '#');
      } else {
        ctaEl.setAttribute('data-osjv-href', url || '');
      }
    }

    function applySelection(btn) {
      if (!btn) return;

      optionBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      var qty = parseInt(btn.getAttribute('data-qty') || "1", 10);
      var intervalDays = btn.getAttribute('data-interval-days') || "";
      currentQty = qty || 1;
      currentIntervalDays = intervalDays || '';
      var subLine = btn.getAttribute('data-sub-line') || "";
      var ctaCompare = btn.getAttribute('data-cta-compare') || "";
      var ctaPrice = btn.getAttribute('data-cta-price') || "";
      var refillLine = btn.getAttribute('data-refill-line') || "";

      var refillEachPrice = btn.getAttribute('data-refill-each-price') || "";
      var refillNoun = btn.getAttribute('data-refill-noun') || "";

      // Dynamic gift unlocking
      giftEls.forEach(function (gift) {
        var req = parseInt(gift.getAttribute('data-requires-qty') || "1", 10);
        var lockline = qs(gift, '[data-osjv-gift-lockline]');

        if (qty >= req) {
          gift.classList.remove('is-locked');
          if (lockline) lockline.textContent = '';
        } else {
          gift.classList.add('is-locked');
          if (lockline) lockline.textContent = req + '+ ' + (req === 1 ? 'Bag' : 'Bags');
        }
      });

      // Dynamic rebill messaging
      if (rebillEl) {
        // Example: "Subscribe & Save - Every 60 Days - 30% Off First Order"
        // subLine is editor-controlled for accuracy.
        rebillEl.textContent = subLine || (
          'Subscribe & Save' +
          (intervalDays ? (' - Every ' + intervalDays + ' Days') : '')
        );
      }

      // Inline "refill ships every X days at $Y each"
      // - Uses refill_each_price (rebill per-bag price) instead of the first-order price
      // - Auto bag/bags based on qty (unless noun override is set)
      if (benefitRefillEl) {
        var builtRefill = buildRefillBenefitLine(qty, intervalDays, refillEachPrice, refillNoun);

        var manualRefill = (refillLine && String(refillLine).trim()) ? String(refillLine).trim() : '';
        var hasDynamicInputs =
          (refillEachPrice && String(refillEachPrice).trim() !== '') ||
          (refillNoun && String(refillNoun).trim() !== '');

        // If dynamic inputs exist, they MUST win (so refill_each_price + noun actually work).
        // Otherwise, allow manual refill_line override.
        benefitRefillEl.textContent = hasDynamicInputs ? builtRefill : (manualRefill || builtRefill);
      }

      // CTA compare / price
      // If editor value is "/each", convert to TOTAL based on selected qty
      var ctaPriceDisplay = ctaPrice;

      if (ctaPrice && (
        /\/\s*each\b/i.test(ctaPrice) ||
        /\beach\b/i.test(ctaPrice) ||
        /\/\s*ea\.?\b/i.test(ctaPrice)
      )) {
        var eachCents = moneyToCents(ctaPrice);
        if (eachCents !== null) {
          ctaPriceDisplay = formatCents(eachCents * qty);
        }
      }

      if (ctaCompareEl) ctaCompareEl.textContent = ctaCompare;
      if (ctaPriceEl) ctaPriceEl.textContent = ctaPriceDisplay;

      updateBenefitsVisibility();
      updateSelectFlavorsLink();
      persistGiftsState();
      syncStickyCta();
    }

    function isNutritionOpen() {
      return nutritionModal && !nutritionModal.hasAttribute('hidden');
    }

    function openNutritionModal() {
      if (!nutritionModal) return;

      showNutritionSlideByIndex(currentSlideIndex);

      lastActiveEl = document.activeElement;

      prevHtmlOverflow = document.documentElement.style.overflow || '';
      prevBodyOverflow = document.body.style.overflow || '';
      prevBodyPaddingRight = document.body.style.paddingRight || '';

      prevBodyPosition = document.body.style.position || '';
      prevBodyTop = document.body.style.top || '';
      prevBodyLeft = document.body.style.left || '';
      prevBodyRight = document.body.style.right || '';
      prevBodyWidth = document.body.style.width || '';

      lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      nutritionModal.removeAttribute('hidden');
      nutritionModal.setAttribute('aria-hidden', 'false');

      // ✅ Lock scroll (desktop + iOS) + prevent layout shift when scrollbar disappears
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.documentElement.classList.add('osjv-nutrition-open');
      document.documentElement.style.overflow = 'hidden';

      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
      }

      window.setTimeout(function () {
        if (nutritionCloseBtn) nutritionCloseBtn.focus();
      }, 0);
    }

    function closeNutritionModal() {
      if (!nutritionModal) return;

      nutritionModal.setAttribute('hidden', '');
      nutritionModal.setAttribute('aria-hidden', 'true');

      // ✅ Restore scroll + layout
      document.documentElement.classList.remove('osjv-nutrition-open');
      document.documentElement.style.overflow = prevHtmlOverflow;

      document.body.style.overflow = prevBodyOverflow;
      document.body.style.paddingRight = prevBodyPaddingRight;

      document.body.style.position = prevBodyPosition;
      document.body.style.top = prevBodyTop;
      document.body.style.left = prevBodyLeft;
      document.body.style.right = prevBodyRight;
      document.body.style.width = prevBodyWidth;

      if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, lockedScrollY || 0);
      }
      lockedScrollY = 0;

      if (lastActiveEl && typeof lastActiveEl.focus === 'function') {
        lastActiveEl.focus();
      }
      lastActiveEl = null;
    }

    // Nutrition open buttons
    if (nutritionOpenBtns.length) {
      nutritionOpenBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openNutritionModal();
        });
      });
    }

    // Close button
    if (nutritionCloseBtn) {
      nutritionCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeNutritionModal();
      });
    }

    // Click outside dialog closes (overlay click)
    if (nutritionModal && nutritionDialog) {
      nutritionModal.addEventListener('click', function (e) {
        if (e.target === nutritionModal) closeNutritionModal();
      });

      nutritionDialog.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // ESC closes (scoped to when open)
    document.addEventListener('keydown', function (e) {
      if (!isNutritionOpen()) return;
      if (e.key === 'Escape' || e.keyCode === 27) closeNutritionModal();
    });

    // Options click
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applySelection(btn);
      });
    });

    // Thumbs click
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        currentMainIndex = thumbBtns.indexOf(btn);
        if (currentMainIndex < 0) currentMainIndex = 0;

        setMainImage(btn.getAttribute('data-src'), btn.getAttribute('data-srcset'));

        // Preload around the chosen image so the next clicks are instant
        __osjvPreloadAround(currentMainIndex, 3, 1);

        syncMainNavButtons();
      });
    });

    // Main gallery prev/next
    if (mainPrevBtn) {
      mainPrevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showMainByIndex(currentMainIndex - 1);
      });
    }

    if (mainNextBtn) {
      mainNextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showMainByIndex(currentMainIndex + 1);
      });
    }

    // Sticky CTA click -> mirrors main CTA behavior
    if (stickyCtaEl) {
      stickyCtaEl.addEventListener('click', function (e) {
        // Always persist state before leaving this page
        persistGiftsState();

        // If <a> and href is set, let it navigate naturally.
        if (stickyCtaEl.tagName === 'A') return;

        e.preventDefault();
        var href = stickyCtaEl.getAttribute('data-osjv-href') || '';
        if (href) window.location.href = href;
      });
    }

    // CTA click -> go to Select Flavors page with params
    if (ctaEl) {
      ctaEl.addEventListener('click', function (e) {
        // Always persist state before leaving this page
        persistGiftsState();

        // If <a> and href is set, let it navigate naturally.
        if (ctaEl.tagName === 'A') return;

        e.preventDefault();
        var href = ctaEl.getAttribute('data-osjv-href') || '';
        if (href) window.location.href = href;
      });
    }

    // Try once -> same Select Flavors page, plan=otp, quantity=1, no selling plan
    if (tryOnceEl) {
      tryOnceEl.addEventListener('click', function (e) {
        if (!tryOnceBase) return; // fallback to theme link if set
        e.preventDefault();

        // Persist "1" so Select Flavors can preload (even though gifts are hidden for OTP)
        try { sessionStorage.setItem('osjv_gifts_qty_v1', '1'); } catch (err) {}

        var url = buildUrl(tryOnceBase, {
          quantity: 1,
          plan: 'otp'
        });

        window.location.href = url;
      });
    }

    // Default selection
    var defaultBtn =
      optionBtns.find(function (b) { return b.getAttribute('data-default') === "true"; }) ||
      optionBtns[0];

    applySelection(defaultBtn);

    // Default thumb pressed (only if it matches the current main image)
    if (thumbBtns.length && mainImgEls && mainImgEls.length) {
      function normUrl(u) {
        if (!u) return '';
        try {
          var url = new URL(u, window.location.origin);
          return url.pathname + url.search;
        } catch (e) {
          return String(u);
        }
      }

      var mainSrc = (mainImgEls[0].getAttribute('src') || mainImgEls[0].currentSrc || '');
      var mainKey = normUrl(mainSrc);

      var matched = null;
      thumbBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        if (!matched) {
          var btnSrc = b.getAttribute('data-src') || '';
          if (normUrl(btnSrc) === mainKey) matched = b;
        }
      });

      if (matched) matched.setAttribute('aria-pressed', 'true');
    }

    // Init main nav (hide if 0–1 thumbs, set current index from pressed thumb)
    if (thumbBtns && thumbBtns.length) {
      thumbBtns.forEach(function (b, i) {
        if (b.getAttribute('aria-pressed') === 'true') currentMainIndex = i;
      });
    }
    syncMainNavButtons();

    // Prime the cache right away for fast first-time browsing
    __osjvPreloadAround(currentMainIndex, 4, 2);

    // Then quietly preload everything else in the background
    __osjvIdlePreloadAll();

    // Sticky CTA visibility: show only when main CTA is out of viewport
    if (stickyWrap && ctaEl && 'IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          var entry = entries && entries[0];
          var inView = !!(entry && entry.isIntersecting);

          if (inView) {
            stickyWrap.setAttribute('hidden', '');
          } else {
            stickyWrap.removeAttribute('hidden');
            syncStickyCta();
          }
        }, {
          root: null,
          threshold: 0.15
        });

        io.observe(ctaEl);
      } catch (e) {}
    } else if (stickyWrap && ctaEl) {
      // Fallback: simple scroll check
      function isInViewport(el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.left < (window.innerWidth || document.documentElement.clientWidth);
      }

      function onScrollFallback() {
        var inView = isInViewport(ctaEl);
        if (inView) stickyWrap.setAttribute('hidden', '');
        else {
          stickyWrap.removeAttribute('hidden');
          syncStickyCta();
        }
      }

      window.addEventListener('scroll', onScrollFallback, { passive: true });
      window.addEventListener('resize', onScrollFallback);
      onScrollFallback();
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-os-jv-cvr-top-shop]')
      .forEach(function (root) {
        initOne(root);
      });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Theme Editor / Sections API re-render support
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;

    var root = evt.target.querySelector(
      '[data-os-jv-cvr-top-shop]'
    );

    if (root) initOne(root);
  });
})();

